import { SET_USER, UPDATE_USER_ROLE } from '../actions/types';

export default function (state = null, action: any) {
  switch (action.type) {
    case SET_USER:
      return action.payload;
    case UPDATE_USER_ROLE:
      return Object.assign({}, state, {
        currentRole: action.payload,
      });
    default:
      return state;
  }
}
